import React from "react";
import Experience from "../Items/Experience";

const experiencesData = [
  {
    id: 1,
    year: "Jul 2025 – Des 2025",
    degree: "Internship – PT HSK (Web Developer & Data Analyst)",
    isBold: true,
    content:
      "Worked as a Web Developer in the IT Department by developing an employee attendance website and a leave request management system. Assisted in documenting system workflows and organizing structured data for reporting. In the Marketing Department, managed and recapped fertilizer sales data, prepared structured reports, and supported data visualization for internal presentations.",
  },
  {
    id: 2,
    year: "Sep 2023 – Sep 2024",
    degree: "Public Relations Division – Micro IT Community",
    content:
      "Responsible for public communication and content creation, including activity publications and digital campaign materials to enhance the organization's branding.",
  },
  {
    id: 4,
    year: "Jan 2023 – Feb 2023",
    degree: "Mentor – KIP Scholarship Mentoring Program IPB University",
    content:
      "Guided KIP Scholarship mentees by providing motivation and support in academic and personal development during mentoring sessions.",
  },
  {
    id: 3,
    year: "Jul 2022 – Sep 2022",
    degree: "Event Division – Open Recruitment Committee Micro IT",
    content:
      "Organized recruitment events for new members, handled event rundown, and managed coordination between MC and technical teams.",
  },
  {
    id: 5,
    year: "Feb 2022 – Mar 2022",
    degree: "Event Division – Micro IT Upgrading Event",
    content:
      "Contributed to organizing internal upgrading events to support new member development through seminars and training.",
  },
];

function Experiences() {
  return (
    <div className="timeline">
      {experiencesData.map((experience) => (
        <Experience experience={experience} key={experience.id} />
      ))}
      <span className="timeline-line"></span>
    </div>
  );
}

export default Experiences;
